import React from 'react';

function ScrollingTextSection() {
  return (
    <section className="scrolling-text-section">
      <div className="scrolling-text-container">
        <div className="scrolling-text">
          <p>
            <a href="/srs">The selected abstracts for NCVPRIPG'26 have been announced.</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default ScrollingTextSection;
